export default __webpack_public_path__ + "static/media/Marketing_strategy_SVG.4cdbaebc.svg";